import styled from '@emotion/styled'

const StyledContainer = styled.div``

export default StyledContainer
